import {
    getDataWithParams,
    getAllData,
    uploadData,
    postData,
    destroyData,
    errorHelper
} from '@/store/api/method'
const initialState = () => ({
    item: {},
    detail: {},
    msg: 'Jaringan Bermasalah',
    status: 0,
    request: {
        page: 1,
        show: 10,
        sortBy: "updated_at",
        sorting: "DESC",
        search: null
    },
})
const state = initialState
const getters = {
    getItem: state => state.item || {last_page: 0, data: [], total: 0},
    getDetail: state => state.detail || {student: {}},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status
}

const actions = {
    async fetchData({
        commit, state
    }, {url, request}) {
        try {
            state.request = request
            const response = await getDataWithParams(url,request);
            commit('SET_ITEM', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getDetailData({
        commit
    }, url) {
        try {
            const response = await getAllData(url);
            commit('SET_DETAIL', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async upload({
        commit
    }, {url, data}) {
        try {
            const response = await uploadData(url,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async confirmLectureSeminar(_, url) {
        try {
            const response = await postData(url,{});
            return response.data
        } catch (err) {
            let error = {
                msg: 'Jaringan Bermasalah',
                status: 0,
            }
            if(err.response.status == 400){
                error.msg = err.response.data.msg
                error.status = err.response.data.status
            }
            return error
        }
    },
    async destroy({
        commit
    }, url) {
        try {
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async registrationThesis(_, {payload, thesis_id}) {
        try {
            const response = await postData(`seminar/thesis/${thesis_id}`, payload);
            return response.data
        } catch (err) {
            return errorHelper(err)
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Mohon Periksa Kembali'
            state.status = 0
        }
    },
    SET_ITEM(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.item = response.data
    },
    SET_DETAIL(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.detail = response.data
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}